import type { JSX } from 'react';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { SortableTableHeaders } from '@/shared/components/SortableTableHeaders';
import type { SortState } from '@/shared/types/table-filters.types';
import type { JobPosition } from '../types/jobPosition.types';
import { JobPositionRow } from './JobPositionRow';

export interface JobPositionTableProps {
  jobPositions: JobPosition[];
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (jobPosition: JobPosition) => void;
  onDelete: (id: string) => void;
  onArchive: (id: string, archive: boolean) => void;
  onNavigate: (jobPosition: JobPosition) => void;
}

const SORTABLE_HEADERS = [
  { key: 'title', label: 'Position', className: 'w-[250px]' },
  { key: 'location', label: 'Location' },
  { key: 'employmentType', label: 'Type' },
  { key: 'remotePolicy', label: 'Remote' },
  { key: 'experienceLevels', label: 'Level' },
  { key: 'status', label: 'Status' },
];

export function JobPositionTable({
  jobPositions,
  sort,
  onToggleSort,
  ...rowHandlers
}: JobPositionTableProps): JSX.Element {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <SortableTableHeaders
              headers={SORTABLE_HEADERS}
              sort={sort}
              onToggleSort={onToggleSort}
            />
            <TableHead className="text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {jobPositions.map((jobPosition) => (
            <JobPositionRow key={jobPosition.id} jobPosition={jobPosition} {...rowHandlers} />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
